import styled from '@emotion/styled'

export const TitleForm = styled.h3`
  
`
